import { render } from "./guest-users.vue?vue&type=template&id=4b34fafb&lang=pug"
import script from "./guest-users.vue?vue&type=script&lang=js"
export * from "./guest-users.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__